<!-- 
create by melody on 2018/11/1 
description:日志管理页面 
-->
<template>
    <div>
        <page-header :title="title"></page-header>
        <div class="search-container">
            <el-form label-width="100px">
                <el-row>
                    <el-col :xl="8" :lg="10" :md="12">
                        <el-form-item :label="$t('m.userName')" style="width: 400px;">
                            <el-input v-model="searchParam.logUserName" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xl="8"  :lg="10"  :md="12">
                        <el-form-item :label="$t('m.logType')" style="width: 400px;">
                           <el-select v-model="searchParam.logType" clearable>
                                <el-option v-for="(item, index) in logTypeList" :key="index" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xl="8"  :lg="10"  :md="12">
                        <el-form-item :label="$t('m.time')" style="width: 400px;">
                            <el-date-picker
                                v-model="rangeDate"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                width="100%"
                                >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item style="width: 400px;">
                    <lap-search-btn :searchParam="searchParam" @successMethod="getDemoList()"></lap-search-btn>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-container">
            <el-table
                ref="multipleTable"
                :data="tableData"
                stripe
                tooltip-effect="dark"
                style="width: 100%;margin: 24px 0"
                >
                <el-table-column
                    type="index"
                    width="55">
                </el-table-column>
                <el-table-column
                    :label="$t('m.userName')"
                    prop="logUserName"
                    >
                </el-table-column>
                <el-table-column
                    prop="logTypeExt"
                    :label="$t('m.logType')"
                    >
                </el-table-column>
                <!--  <el-table-column
                    prop="logType"
                    sortable
                    :label="$t('m.logType')"
                    >
                </el-table-column> -->
                <el-table-column
                    prop="logResultMessage"
                    :label="$t('m.logResultMessage')"
                    >
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    :label="$t('m.time')"
                    >
                </el-table-column>
                <el-table-column
                    prop="clientIp"
                    :label="$t('m.clientIp')"
                    show-overflow-tooltip>
                </el-table-column>
            </el-table>
            <lap-pagination :total="total" :searchParam="searchParam" @successMethod="getDemoList()"></lap-pagination>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            title:{
                firstTitle: this.$t('m.LapModule'),
                secondTitle: this.$t('m.SYSTEM_MANAGE'),
                thirdTitle: this.$t('m.LOG_MANAGE')
            },
            searchParam: {      //查询参数
                logUserName: '',
                logType: '',
                createTimeStart: '',
                createTimeEnd: '',
                pageSize: 10,
                pageNum: 1,
            },
            rangeDate:'',
            tableData: [],  //表数据
            total: 0,   //总数
            logTypeList: []
        }
    },
    methods: {
        getDemoList() {
            let type 
            if(this.rangeDate) {
                this.searchParam.createTimeStart = this.rangeDate[0]
                this.searchParam.createTimeEnd = this.rangeDate[1]
                type = 'getLogListHasDate'
            } else {
                type = 'getLogList'
            }
            this.$commonFunc.commonRequest('get', '/system/log/list/condition', type, this.searchParam)
            .then(res=>{
                this.tableData = res.obj.list
                this.total = res.obj.total
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        },
        getLogTypeList() {
            this.$commonFunc.commonRequest('get', '/system/log/list/logType')
            .then(res=>{
                this.logTypeList = res.obj
            })
            .catch(res=>{
                this.$message.error(res.message)
            })
        }
    },
    mounted() {
        this.getLogTypeList()
        this.getDemoList()
    }
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/sys/LogManage.vue